/**
 * Normalizes a foreign provider's DNI by encoding slashes ('/') for safe URL usage.
 * If the value does not contain '/', returns the original value.
 */
export const normalizeDniSlashes = (value = '') => {
  if (!value || !value.includes('/')) return value

  return encodeURIComponent(value)
}
